var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.657.117h-5.25a8.75 8.75 0 0 0-8.75 8.75v5.25h-5.25v7h5.25v14h7v-14h5.25l1.75-7h-7v-5.25a1.75 1.75 0 0 1 1.75-1.75h5.25v-7Z",
  fill: "#FAB02B"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h35v35H0z"
})))));

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYzNF8yNzczKSI+CjxwYXRoIGQ9Ik0yNi42NTY2IDAuMTE2Njk5SDIxLjQwNjZDMTkuMDg2IDAuMTE2Njk5IDE2Ljg2MDQgMS4wMzg1NyAxNS4yMTk0IDIuNjc5NTFDMTMuNTc4NSA0LjMyMDQ2IDEyLjY1NjYgNi41NDYwNSAxMi42NTY2IDguODY2N1YxNC4xMTY3SDcuNDA2NjJWMjEuMTE2N0gxMi42NTY2VjM1LjExNjdIMTkuNjU2NlYyMS4xMTY3SDI0LjkwNjZMMjYuNjU2NiAxNC4xMTY3SDE5LjY1NjZWOC44NjY3QzE5LjY1NjYgOC40MDI1NyAxOS44NDEgNy45NTc0NSAyMC4xNjkyIDcuNjI5MjZDMjAuNDk3NCA3LjMwMTA3IDIwLjk0MjUgNy4xMTY3IDIxLjQwNjYgNy4xMTY3SDI2LjY1NjZWMC4xMTY2OTlaIiBmaWxsPSIjRkFCMDJCIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNjM0XzI3NzMiPgo8cmVjdCB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wMDAyNDQxNDEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";